export default __webpack_public_path__ + "static/media/emptycall.7514b473.svg";